import { getIdOrLabelFromCategory } from '@modules/common/utils';
import { UUID } from 'v2/core/entities/uuid';
import { getVisibleDataPointsDefaultSize } from '.';
import { QuantifyReportDataPointBase, VisualisationType } from '../store/types';

interface getDefaultSelectedDataPointsOptions {
  reportDataPoints: QuantifyReportDataPointBase[];
  visualisationType: VisualisationType;
  selectionCount?: number;
}

export function getDefaultSelectedDataPoints({
  reportDataPoints,
  visualisationType,
  selectionCount,
}: getDefaultSelectedDataPointsOptions): UUID[] {
  if (!reportDataPoints) {
    return [];
  }

  return reportDataPoints
    .slice(
      0,
      getVisibleDataPointsDefaultSize(visualisationType, selectionCount),
    )
    .map(({ id, category }) =>
      getIdOrLabelFromCategory({
        key: id,
        category,
      }),
    );
}
